<template>
    <div class="">
        <div class="d-sm-flex align-items-center justify-content-between mb-2">
            <div>
                <ol class="breadcrumb fs-sm mb-1">
                <li class="breadcrumb-item">
                    <router-link to="/dashboard">Dashboard</router-link>
                </li>
                <li class="breadcrumb-item active" aria-current="page">Pallet Inspections</li>
            </ol>
                <h4 class="main-title mb-0">Pallet Inspections</h4>
            </div>
            <router-link to="/pallet_inspection/create" v-can="'pallet_inspections.create'" type="submit" class="btn btn-primary" ><i class="ri-list-check fs-18 lh-1"></i> Add Pallet Inspection</router-link>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="card card-one">
                    <div class="card-header d-flex justify-content-between">
                        <h6 class="card-title">Pallet Inspection</h6>
                    </div>
                    <div class="card-body">
                        <input class="form-control mb-2" type="text" placeholder="Type keyword and press enter key" v-model="meta.search" @keypress.enter="search()" />
                        <div class="table-responsive table-responsive-sm">
                            <table class="table table-bordered table-striped table-sm">
                                <thead>
                                    <tr style="background-color:#9b9b9b;color:white;">
                                        <th class="text-center">#</th>
                                        <th @click="sort('receipt_no')">
                                            Receipt No
                                            <span>
                                                <i v-if="meta.keyword == 'receipt_no' && meta.order_by == 'asc'" class="ri-arrow-up-line"></i>
                                                <i v-else-if="meta.keyword == 'receipt_no' && meta.order_by == 'desc'" class="ri-arrow-down-line"></i>
                                                <i v-else class="fas fa-sort"></i>
                                            </span>
                                        </th>
                                        <th @click="sort('receipt_date_time')">
                                            Date
                                            <span>
                                                <i v-if="meta.keyword == 'receipt_date_time' && meta.order_by == 'asc'" class="ri-arrow-up-line"></i>
                                                <i v-else-if="meta.keyword == 'receipt_date_time' && meta.order_by == 'desc'" class="ri-arrow-down-line"></i>
                                                <i v-else class="fas fa-sort"></i>
                                            </span>
                                        </th>
                                        <th @click="sort('supplier_id')">
                                            Supplier
                                            <span>
                                                <i v-if="meta.keyword == 'supplier_id' && meta.order_by == 'asc'" class="ri-arrow-up-line"></i>
                                                <i v-else-if="meta.keyword == 'supplier_id' && meta.order_by == 'desc'" class="ri-arrow-down-line"></i>
                                                <i v-else class="fas fa-sort"></i>
                                            </span>
                                        </th>
                                        <!-- <th @click="sort('transporter_id')">
                                            Transporter
                                            <span>
                                                <i v-if="meta.keyword == 'transporter_id' && meta.order_by == 'asc'" class="ri-arrow-up-line"></i>
                                                <i v-else-if="meta.keyword == 'transporter_id' && meta.order_by == 'desc'" class="ri-arrow-down-line"></i>
                                                <i v-else class="fas fa-sort"></i>
                                            </span>
                                        </th> -->
                                        <th @click="sort('wagon_no')">
                                            Wagon No
                                            <span>
                                                <i v-if="meta.keyword == 'wagon_no' && meta.order_by == 'asc'" class="ri-arrow-up-line"></i>
                                                <i v-else-if="meta.keyword == 'wagon_no' && meta.order_by == 'desc'" class="ri-arrow-down-line"></i>
                                                <i v-else class="fas fa-sort"></i>
                                            </span>
                                        </th>
                                        <th class="text-center" v-can="'pallet_inspections.delete'">Status</th>
                                        <th class="text-center" v-can="'pallet_inspections.update'">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="inspections.length==0">
                                        <td colspan="9" class="text-center">No records found</td>
                                    </tr>
                                    <tr v-for="inspection, key in inspections" :key="key">
                                        <td class="text-center">{{ meta.from + key }}</td>
                                        <td>{{ inspection.receipt_no}}</td>
                                        <td>{{ convertDateFormat(inspection.receipt_date_time) }}</td>
                                        <td>{{ inspection?.supplier?.supplier_name}}</td>
                                        <!-- <td>{{ trip.transporter?.transporter_name }}</td> -->
                                        <td>{{ inspection.wagon_no }}</td>
                                        <!-- <td>{{ trip.container_no }}</td> -->
                                        <td v-if="inspection.status == 'Pending'" v-can="'pallet_inspections.delete'" class="text-center"><span class="badge badge-pill bg-warning">{{ inspection.status }}</span></td>
                                        <td v-else class="text-center"><span class="badge badge-pill bg-success">{{ inspection.status }}</span></td>
                                        
                                        <td class="text-center" v-can="'pallet_inspections.update'">
                                            <nav>
                                                <a href="javascript:void(0)" class="text-success me-2" @click.prevent="edit(inspection)" v-if="inspection.status=='Pending'"><i class="ri-pencil-line fs-18 lh-1"></i></a>
                                                <a href="javascript:void(0)" class="text-success me-2" @click.prevent="view(inspection)"><i class="ri-eye-line fs-18 lh-1"></i></a>
                                                <a target="_blank" :href="$store.getters.apiUrl+'downloadInspectionReport?inspection_id='+inspection.inspection_id" class="text-success me-2"><i class="ri-download-line fs-18 lh-1"></i></a>
                                            </nav>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="card-footer">
                        <div class="d-flex justify-content-between align-items-center">
                            <select class="form-select from-select-sm width-75" v-model="meta.per_page" @change="onPerPageChange">
                                <option>10</option>
                                <option>15</option>
                                <option>20</option>
                                <option>25</option>
                                <option>30</option>
                            </select>
                            <span>Showing {{ meta.from }} to {{ meta.to }} of {{ meta.totalRows }} entries</span>
                            <Pagination :maxPage="meta.maxPage" :totalPages="meta.lastPage" :currentPage="meta.page" @pagechanged="onPageChange" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Pagination from "@/components/Pagination.vue"
    import moment from "moment";
    export default {
        components: {
            Pagination,
        },
        data() {
            return {
                meta: {
                    search: "",
                    order_by: "desc",
                    keyword: "inspection_id",
                    per_page: 10,
                    totalRows: 0,
                    page: 1,
                    lastPage: 1,
                    from: 1,
                    to: 1,
                    maxPage: 1,
                    trashed: false,
                    status:''
                },
                from_name:'',

                inspections: [],
                errors: [],
                status: true,
            };
        },
        beforeRouteEnter(to, from, next) {
            next((vm) => {
                vm.from_name = from.name
            })
        },
        mounted() {
            if(this.from_name == 'Dashboard') {
                this.meta.status = this.$store.getters.status;
            }
            this.index();
        },

        methods: {
            convertDateFormat(date) {
                return moment(date).format("DD-MM-YYYY");
            },
            search() {
                let vm = this;
                vm.meta.page = 1;
                vm.index();
            },
            index() {
                let vm = this;
                if(this.$store.getters.page){
                    this.meta.page = this.$store.getters.page;
                }
                vm.$store
                    .dispatch("post", { uri: "paginateInspections", data: vm.meta })
                    .then((response) => {
                        vm.inspections = response.data.data;
                        vm.meta.totalRows = response.data.meta.total;
                        vm.meta.lastPage = response.data.meta.last_page;
                        vm.meta.from = response.data.meta.from;
                        vm.meta.to = response.data.meta.to;
                        // this.$store.dispatch('setPage', null);
                        //vm.meta.lastPage = response.data.meta.last_page;
                        vm.meta.maxPage = vm.meta.lastPage >= 3 ? 3 : vm.meta.lastPage;
                    })
                    .catch(function (error) {
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            edit(inspection) {
                // this.$store.dispatch('setPage',this.meta.page);
                this.$router.push("/pallet_inspection/" + inspection.inspection_id + "/edit");
            },
            view(inspection){
                this.$router.push("/pallet_inspection/" + inspection.inspection_id + "/view");
            },
            deleteTrip(inspection) {
                let vm = this;
                let loader = vm.$loading.show();
                vm.$store
                    .dispatch("post", { uri: "deleteInspection", data: inspection })
                    .then((response) => {
                        loader.hide();
                        vm.$store.dispatch("success", response.data.message);
                        vm.index();
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            onPageChange(page) {
                let vm = this;
                vm.meta.page = page;
                vm.index();
            },
            sort(field) {
                let vm = this;
                vm.meta.keyword = field;
                vm.meta.order_by = vm.meta.order_by == "asc" ? "desc" : "asc";
                vm.index();
            },
            onPerPageChange() {
                this.meta.page = 1;
                this.index();
            },
        },
    };
</script>
